const CHAIN_ALIASES: Record<string, string> = {
  sol: 'solana',
  solana: 'solana',
  eth: 'ethereum',
  ethereum: 'ethereum',
  erc20: 'ethereum',
  base: 'base',
  bsc: 'bsc',
  bnb: 'bsc',
  bnbchain: 'bsc',
  binancesmartchain: 'bsc',
  arb: 'arbitrum',
  arbitrum: 'arbitrum',
  arbitrumone: 'arbitrum',
  polygon: 'polygon',
  matic: 'polygon',
  avax: 'avalanche',
  avalanche: 'avalanche',
  optimism: 'optimism',
  opmainnet: 'optimism',
  sui: 'sui',
  ton: 'ton',
  tron: 'tron',
  trx: 'tron',
  aptos: 'aptos',
  sei: 'sei-v2',
  seiv2: 'sei-v2',
  linea: 'linea',
  blast: 'blast',
  sonic: 'sonic',
  fantom: 'fantom',
  ftm: 'fantom',
  hyperliquid: 'hyperevm',
  hyperevm: 'hyperevm',
  robinhood: 'robinhood',
  robinhoodchain: 'robinhood',
  rhchain: 'robinhood',
}

const CASE_INSENSITIVE_ADDRESS_CHAINS = new Set([
  'ethereum', 'base', 'bsc', 'arbitrum', 'polygon', 'avalanche', 'optimism',
  'linea', 'blast', 'sonic', 'fantom', 'hyperevm', 'robinhood',
])

export function canonicalAlphaChain(chain: string | null | undefined): string {
  const raw = chain?.trim()
  if (!raw) return 'unknown'
  const compact = raw.toLowerCase().replace(/[ _-]/g, '')
  return CHAIN_ALIASES[compact] ?? raw.toLowerCase()
}

export function alphaContractAddressMatches(
  chain: string | null | undefined,
  left: string,
  right: string,
): boolean {
  const canonicalChain = canonicalAlphaChain(chain)
  if (
    CASE_INSENSITIVE_ADDRESS_CHAINS.has(canonicalChain)
    || left.toLowerCase().startsWith('0x')
    || right.toLowerCase().startsWith('0x')
  ) {
    return left.toLowerCase() === right.toLowerCase()
  }
  return left === right
}
